<div class="widget-chart-legend">
  <div class="legend-list">
    <div class="legend-item" *ngFor="let item of items">
      <div class="legend-icon" [ngClass]="item.icon" [style.color]="item.color" [style.opacity]="item.opacity"></div>
      <div class="legend-label">{{ item.label }}</div>
    </div>
  </div>
</div>
